import React from 'react';
import { Layout } from 'fronton-react';
import { CoatHangerIcon } from '@fronton/icons-react';
import {
  CategoryImageSection,
  CreditBlock,
  DesignRegistrationPanel,
  HeaderSection,
  InspirationGallery,
  LinkBanner,
  OtherSection,
  RootLayout,
  Section,
} from 'common/components';
import { PromoBlock } from 'remotes/promo-block';
import { SpecialOffer } from 'remotes/special-offer';
import { ExperimentCookie } from 'types/common';
import { StorageBanner } from '../components/storage-banner';
import { StorageBlackHeader } from '../components/storage-black-header';
import { StorageCategories } from '../components/storage-categories';
import { StorageGallerySection } from '../components/storage-gallery-section';
import { StorageFaq } from '../components/storage-faq';
import { StorageProjects } from '../components/storage-projects';
import { StorageReview } from '../components/storage-review';
import {
  STORAGE_CDN_PATH,
  STORAGE_ELEMENT_BLOCK,
  STORAGE_LANDING_NAME,
  STORAGE_PATH,
} from '../storage-constants';
import {
  CATALOG_BANNER,
  CATALOG_BANNER_B,
  CATALOG_BANNER_C,
  INSPIRATION_GALLERY,
  MORE_STORAGE_B,
  MORE_STORAGE_C,
  SPLIT_BANNER,
} from './updated-storage-constants';

/**
 * Вью лендинга Спасео Куб
 */
export const UpdatedStorage: React.FC<{ experimentCookie: ExperimentCookie; regionId: string }> = ({ experimentCookie, regionId }) => {
  const signLink = `/zapis-onlayn/?department_no=14&region_id=${regionId}`;

  return (
    <RootLayout currentPage={STORAGE_PATH}>
      {experimentCookie === 'B'
        ? (
          <HeaderSection
            img={{
              ldSrcSet: `${STORAGE_CDN_PATH}/header/b/header-ld.jpg/header-ld.jpg`,
              dSrcSet: `${STORAGE_CDN_PATH}/header/b/header-d.jpg/header-d.jpg`,
              tSrcSet: `${STORAGE_CDN_PATH}/header/b/header-t.jpg/header-t.jpg`,
              mSrcSet: `${STORAGE_CDN_PATH}/header/b/header-m.jpg/header-m.jpg`,
              alt: "Изображение интерьера",
            }}
            bgColor="#FDC300"
            description="Поможем выбрать мебель и сделаем дизайн-проект для удобного хранения ваших вещей. Бережно доставим и установим."
            mediaType="image"
            textColor="text-primary"
            title="Бесплатное проектирование систем хранения в Лемана ПРО"
          />
        ) : (
          <StorageBlackHeader />
        )}
      <DesignRegistrationPanel
        newVersion
        structure={{
          panel: {
            content: {
              leftIcon: CoatHangerIcon,
              iconColor: 'text-invert',
              iconStrokeWidth: 1.5,
              iconType: 'outline',
              text: 'Запишитесь на бесплатное проектирование или сделайте проект в онлайн-конструкторе',
            },
            actionBlock: [
              {
                elementBlock: STORAGE_ELEMENT_BLOCK,
                href: '/3d-planirovshchiki/hranenie/',
                invert: true,
                label: 'Спроектировать самому',
                target: '_blank',
                variant: 'pseudo',
              },
              {
                elementBlock: STORAGE_ELEMENT_BLOCK,
                href: signLink,
                label: 'Записаться',
                target: '_blank',
                variant: 'accent',
              },
            ],
          },
          mobilePanel: {
            mobileButton: {
              elementBlock: STORAGE_ELEMENT_BLOCK,
              href: signLink,
              label: 'Записаться',
              target: '_blank',
              variant: 'accent',
            },
            content: {
              icon: CoatHangerIcon,
              iconColor: 'text-invert',
              iconType: 'outline',
              text: 'Запишитесь на бесплатное проектирование или сделайте проект в онлайн-конструкторе',
            },
            actionBlock: [
              {
                elementBlock: STORAGE_ELEMENT_BLOCK,
                href: signLink,
                label: 'Записаться',
                target: '_blank',
                variant: 'accent',
              },
            ],
          },
        }}
      />
      <Layout>
        {experimentCookie === 'B' && (
          <StorageCategories variant='B' />
        )}

        <PromoBlock elementBlock={STORAGE_ELEMENT_BLOCK} />
        <SpecialOffer elementBlock={STORAGE_ELEMENT_BLOCK} />
        <StorageProjects elementBlock={STORAGE_ELEMENT_BLOCK} />
        <LinkBanner
          {...CATALOG_BANNER}
          {...(experimentCookie === 'B' ? CATALOG_BANNER_B : CATALOG_BANNER_C)}
        />

        <StorageGallerySection regionId={regionId} title="Раскладываем вещи по полочкам" />

        <StorageBanner elementBlock={STORAGE_ELEMENT_BLOCK} variant={experimentCookie} />

        <CategoryImageSection
          categories={experimentCookie === 'B' ? MORE_STORAGE_B : MORE_STORAGE_C}
          elementName="Больше систем хранения"
          elementBlock={STORAGE_ELEMENT_BLOCK}
          title="Больше систем хранения"
        />
      </Layout>

      <StorageReview elementBlock={STORAGE_ELEMENT_BLOCK} signLink={signLink} />

      <Layout>
        <LinkBanner {...SPLIT_BANNER} />
        <InspirationGallery
          description="Поможем создать интерьер, в котором всё смотрится гармонично."
          elementBlock={STORAGE_ELEMENT_BLOCK}
          elementName="Когда дом в одном стиле"
          imageList={INSPIRATION_GALLERY}
          signHref={signLink}
          title="Когда дом в одном стиле"
        />
      </Layout>

      <Section as="div">
        <OtherSection
          elementBlock={`${STORAGE_ELEMENT_BLOCK} / other`}
          landingName={STORAGE_LANDING_NAME}
          promotionName={`${STORAGE_ELEMENT_BLOCK}_bottom`}
          title="Вам также могут понравиться"
        />
      </Section>

      <Layout>
        <CreditBlock
          overpayment={{
            6: 0,
            10: 0,
            12: 1.6,
            18: 7.27,
            24: 13.13,
          }}
        />
        <StorageFaq elementBlock={STORAGE_ELEMENT_BLOCK} />
      </Layout>
    </RootLayout >
  );
};
